import styled, { keyframes, withTheme } from 'styled-components';

const fadeIn = keyframes`
    0% {
        opacity: 0;
        visibility: hidden;
    }
    100% {
        opacity: 1;
        visibility: visible;
    }
`;

const getDataByUser = (user, senderData, receiverData, defaultData) => {
    switch (user) {
    
    case 'sender':
        return senderData;
    case 'receiver':
        return receiverData;
    default:
        return defaultData;
    }
};

const BoxStyled = styled.div`
  background-color: ${ ({ highlighted, user, theme: { errorColor, primaryLighterColor } }) => !!highlighted ? errorColor : getDataByUser(user, '#ECE7E3', primaryLighterColor, '#eee') };
  font-size: 12px;
  font-weight: 400;
  padding: 10px;
  position: relative;
  margin-bottom: 5px;
  ${ ({ user }) => getDataByUser(user, 'margin-right: 7px', 'margin-left: 7px') };
  max-width: fit-content;
  word-break: break-word;
  width: max-content;
  ::before{
    ${ ({ user }) => getDataByUser(user, 'border-right: 7px solid transparent;', 'border-left: 7px solid transparent') }
    border-top: 7px solid ${ ({ user, theme: { opacityColor, primaryLighterColor } }) => getDataByUser(user, '#ECE7E3', primaryLighterColor, '#eee') };
    content: '';
    height: 0;
    ${ ({ user }) => getDataByUser(user, 'right: -7px', 'left: -7px') };
    position: absolute;
    top: 0;
    width: 0;
  }
`;
BoxStyled.displayName = 'BoxStyled';

export const Box = withTheme(BoxStyled);
Box.displayName = 'Box';

export const Row = styled.div`
    animation: ${ fadeIn } .5s ease;
    animation-fill-mode: forwards;
    display: flex;
    flex-direction: row;
    ${ ({ user }) => getDataByUser(user, 'justify-content: flex-end') };
    width: 100%;
`;

Row.displayName = 'Row';

const BoxNameStyled = styled.div`
  color: #22216F;
  font-size: 10px;
  font-weight: 400;
  position: relative;
  margin-bottom: 5px;
  ${ ({ user }) => getDataByUser(user, 'margin-right: 7px', 'margin-left: 7px') };
  max-width: 80%;
  width: max-content;
  ::before{
    ${ ({ user }) => getDataByUser(user, 'border-right: 7px solid transparent;', 'border-left: 7px solid transparent') }
    border-top: 7px solid ${ ({ user, theme: { opacityColor, primaryLighterColor } }) => getDataByUser(user, '#ECE7E3', primaryLighterColor, '#eee') };
    content: '';
    height: 0;
    ${ ({ user }) => getDataByUser(user, 'right: -7px', 'left: -7px') };
    position: absolute;
    top: 0;
    width: 0;
  }
`;
BoxNameStyled.displayName = 'BoxNameStyled';

export const BoxName = withTheme(BoxNameStyled);
BoxName.displayName = 'BoxName';
